module.exports = new __parcel__URL__("mario-kart-8.e964caa0.jpg").toString();